export const handleDecimalValueOnOnChange = value => {
    const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
    return value.match(regex)[0];
};

export const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
export const formatNumberWithoutCommas = (number) => {
    return number.toString().replace(/,/g, '');
  };
